
import { Vue, Component } from 'vue-property-decorator';

import AuthorizationService from '@/api/AuthorizationService';
import ManagerService from '@/api/ManagerService';

@Component({
  components: {}
})
export default class AuthTokenBusiness extends Vue {
  service: AuthorizationService = new AuthorizationService();
  managerService: ManagerService = new ManagerService();

  get businessManagerId() {
    return this.$route.params.businessManagerId;
  }

  async init() {
    const token = await this.service.switchToken(this.businessManagerId);

    if (token) {
      this.service.setCredentials(token);
    }

    window.location.assign('/');
  }

  mounted() {
    this.init();
  }
}
